<template>
  <div>
    <div
      v-if="$can('write', 'notifications')"
      class="d-flex justify-content-between mb-2"
    >
      <b-button
        variant="primary"
        @click="$router.push('/create-notification')"
      >
        Create Notification
      </b-button>
      <div class="d-flex">
        <b-button
          class="btn-icon rounded-circle"
          variant="flat-primary"
          @click="fetchNotifications"
        >
          <feather-icon icon="RefreshCwIcon" />
        </b-button>
        <b-button
          variant="primary"
          @click="$router.push('/add-device')"
        >
          Add Device
        </b-button>
      </div>
    </div>
    <b-card>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loadingNotifications"
      >
        <b-table
          fixed
          :fields="tableColumns"
          :items="notifications"
          class="mb-2 text-center"
        >
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="`light-${data.item.status === 'published' ? 'success' : 'primary'}`"
              class="text-capitalize"
            >
              {{ data.item.status }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
            >

              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item
                v-if="data.item.status === 'published'"
                @click="viewNotification(data.item.id)"
              >
                <feather-icon icon="EyeIcon" />
                <span class="align-middle ml-50">View</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="data.item.status === 'draft'"
                @click="editNotification(data.item.id)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <!-- <base-pagination
          v-model="page"
          :total="total"
          @new-per-page="perPage = $event"
        /> -->
        <b-button
          class="mr-2"
          variant="outline-danger"
          @click="resetHandler"
        >
          Reset
        </b-button>
        <b-button
          v-if="total > 10"
          variant="outline-primary"
          @click="nextHandler"
        >
          Next
        </b-button>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BButton, BTable, BCard, BOverlay, BDropdown, BDropdownItem, BBadge,
} from 'bootstrap-vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import notificationsStore from '../store'
import useNotifications from '../hooks/useNotifications'
// import BasePagination from '@/UI/BasePagination.vue'

export default {
  components: {
    BButton, BTable, BCard, BOverlay, BDropdown, BDropdownItem, BBadge,
  },
  setup(_, ctx) {
    useRegisterStoreModule('notifications', notificationsStore)

    return {
      ...useNotifications(ctx),
    }
  },
}
</script>

<style>

</style>
